import request from '@/axios'

export function List_role (query, customerId, params) {
  
  return request({
    url: `/role/list_role/${query.limit}/${customerId}?page=${query.page}`,
    method: 'GET',
    params
  })
}

export function Create_role (payload) {
  
  return request({
    url:'/role/create_role',
    method:'POST',
    data:payload
  })

}

export function Fetch_list_action (payload) {
  return request({
    url:'role/fetch_module_action',
    method:'POST',
    data:payload
  })
}


export function ModluePermission (payload) {
  return request({
    url:'role/module_permission',
    method:'POST',
    data:payload
  })
}

export function Delete_Role (id, customer_id) {
  return request({
    url:`role/delete_role/${id}/${customer_id}`,
    method:'GET'
  })
  
}

export function FetchEditRole (id) {
  return request({
    url:`role/fetch_role/${id}`,
    method:'GET'
  })
  
}

export function UpdateRoleList (query) {
  return request({
    url:'/role/edit_role',
    method: 'PUT',
    data: query
  })
}

export function FetchSubModule (id, customerId) {
  return request({
    url:`/role/fetch_sub_modules/${id}/${customerId}`,
    method:'GET'
  })
}
export function SubModulePermission (payload) {
  return request({
    url:'/role/sub_module_permission',
    method:'POST',
    data: payload
  })
}
export function ModulePermission (payload, customer_id) {
  return request({
    url:`/V1/role/update_module_permission/${customer_id}`,
    method:'POST',
    data: payload
  })
}


export function AllModulePermission (payload) {
  return request({
    url:'/role/all_module_permission',
    method:'POST',
    data: payload
  })
}

// http://localhost:8000/api/role/all_module_permission


export function newFetchAllRoles (customer_id, payload) {
  return request({
    url:`V1/role/fetch_module_action/${customer_id}`,
    method:'POST',
    data: payload
  })
}

export function updatePermissions (customer_id, payload) {
  return request({
    url:`V1/role/update_module_action/${customer_id}`,
    method:'POST',
    data: payload
  })
}